import { Modal } from 'antd';

import { usePayWithBonusesMutation } from '@app/api/Loyalty';
import type { ApplyPercentageDiscountProps } from '@app/components/RecordModal/components/RecordPayment/types';
import { SAVE, SUCCESS } from '@app/constants';
import { useUserPrint } from '@app/hooks';
import { useNotification } from '@app/providers/NotificationProvider/NotificationContext';
import { handleCatchError } from '@app/services';

export const ApplyPercentageDiscount: React.FC<
  ApplyPercentageDiscountProps
> = ({
  isOpen,
  setIsOpen,
  percentageDiscount,
  cardId,
  cardNumber,
  recordId,
  initTable,
  getRecordInfoHandler,
  fetchPayments,
}) => {
  const { activeBranchId: ActiveBranchId } = useUserPrint();
  const { showNotification } = useNotification();

  const [payWithBonuses, { isLoading }] = usePayWithBonusesMutation();

  const handleCancel = () => {
    setIsOpen(false);
  };

  const handleSave = async () => {
    try {
      await payWithBonuses({
        recordId,
        ActiveBranchId,
        data: {
          CardId: cardId,
          CardNumber: cardNumber,
          BonusesToExceed: percentageDiscount,
          CardType: 'LoyaltyDiscount',
        },
      }).unwrap();

      showNotification('Скидка успешно применена', SUCCESS);
      handleCancel();

      await getRecordInfoHandler();
      await initTable();
      await fetchPayments();
    } catch (error) {
      showNotification(handleCatchError(error));
    }
  };

  return (
    <Modal
      open={isOpen}
      onCancel={handleCancel}
      title="Применить скидку"
      onOk={handleSave}
      okText={SAVE}
      okButtonProps={{
        loading: isLoading,
      }}
      cancelButtonProps={{
        disabled: isLoading,
      }}
    >
      Вы уверены, что хотите применить скидку?
    </Modal>
  );
};
